import { useState, useEffect } from 'react';
import { getAdminUserNames } from '../adminApi';

let _cache = null;

export function useUserNames() {
  const [names, setNames] = useState(_cache || {});

  useEffect(() => {
    if (_cache) return;
    getAdminUserNames()
      .then(data => { _cache = data; setNames(data); })
      .catch(() => {});
  }, []);

  return names;
}

export function resolveUserName(names, userId) {
  if (!userId) return '—';
  if (names[userId]) return names[userId];
  return userId.length > 18
    ? userId.slice(0, 8) + '…' + userId.slice(-4)
    : userId;
}
